module.exports = __webpack_public_path__ + "img/hohlschnitt_himmelblau_ral5015.782a36d0.jpg";